export default __webpack_public_path__ + "static/media/main1.91d0267c.png";